/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Operation_Not_AllowedInputs */

const en_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email/password accounts are not enabled.`)
};

const fr_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les comptes email/mot de passe ne sont pas activés.`)
};

const de_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-/Passwortkonten sind nicht aktiviert.`)
};

const it_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli account e-mail/password non sono abilitati.`)
};

const ru_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учетные записи электронной почты и паролей не активированы.`)
};

const es_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cuentas de correo electrónico/contraseña no están habilitadas.`)
};

const zh_cn2_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件/密码帐户未启用。`)
};

const ja_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子メール/パスワード アカウントが有効になっていません。`)
};

const hi_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल/पासवर्ड खाते सक्रिय नहीं हैं।`)
};

const pt_pt2_login_error_operation_not_allowed = /** @type {(inputs: Login_Error_Operation_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As contas de e-mail/senha não estão ativadas.`)
};

/**
* | output |
* | --- |
* | "Email/password accounts are not enabled." |
*
* @param {Login_Error_Operation_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_operation_not_allowed = /** @type {((inputs?: Login_Error_Operation_Not_AllowedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Operation_Not_AllowedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_operation_not_allowed(inputs)
	if (locale === "de") return de_login_error_operation_not_allowed(inputs)
	if (locale === "it") return it_login_error_operation_not_allowed(inputs)
	if (locale === "ru") return ru_login_error_operation_not_allowed(inputs)
	if (locale === "es") return es_login_error_operation_not_allowed(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_operation_not_allowed(inputs)
	if (locale === "ja") return ja_login_error_operation_not_allowed(inputs)
	if (locale === "hi") return hi_login_error_operation_not_allowed(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_operation_not_allowed(inputs)
	return en_login_error_operation_not_allowed(inputs)
});